import Vue from 'vue';
import VueRouter from 'vue-router';

import List from '../components/list/List.vue';
// import Product from '../components/product/Product.vue';
import Checkout from '../components/checkout/Checkout.vue';
import Result from '../components/Result.vue';
import OrderStatus from '../components/OrderStatus.vue';

import PD from '../components/test/product-details.vue';
import ProductDetails from '../components/product/product-details.vue';

Vue.use(VueRouter);

const routes = [
  // { path: '/', component: Test },
  {
    path: '/new/product-details/:module_id/:product_id',
    component: ProductDetails,
    props: (route) => {
      return {
        module_id: parseInt(route.params.module_id),
        product_id: parseInt(route.params.product_id),
      };
    }
  },

  {
    path: '/test/product-details/:module_id/:product_id',
    component: PD
  },
  {
    path: '/result/:module_id',
    component: Result
  },
  {
    path: '/result/:module_id/:order_id',
    component: Result
  },
  {
    path: '/order-status/:module_id/:order_id/:unique_id',
    component: OrderStatus
  },
  {
    name: 'List',
    path: '/list/:module_id',
    component: List
  },
  {
    path: '/list/:module_id/:vendor_id',
    component: List
  },
  {
    path: '/product/:module_id/:product_id',
    name: 'Product',
    component: ProductDetails,
  },
  {
    path: '/checkout/:module_id',
    component: Checkout,
    name: 'Checkout'
  },
  {
    path: '/checkout/:module_id/:error_code',
    component: Checkout
  },
];

export default new VueRouter({
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js